import { render, staticRenderFns } from "./UiStrings.vue?vue&type=template&id=5dbba857&scoped=true&"
import script from "./UiStrings.vue?vue&type=script&lang=js&"
export * from "./UiStrings.vue?vue&type=script&lang=js&"
import style0 from "./UiStrings.vue?vue&type=style&index=0&id=5dbba857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbba857",
  null
  
)

export default component.exports